/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:08:45
 * @Explain: 公共类
 */

export default {
  'APP.NAME': 'SmartLink',
  'APP.ANNOUNCEMENT':
    'Logged in as an internal admin, you have no edit access.',
  // 公用类
  'COMMON.NUMBER': 'Count',
  'COMMON.TIME.ZONE': 'Timezone',
  'COMMON.LOGIN.OUT': 'Log out',
  'COMMON.YES': 'Yes',
  'COMMON.NO': 'No',
  'COMMON.TIPS': 'Tips',
  'COMMON.CANCEL': 'Cancel',
  'COMMON.DETERMINE': 'Confirm',
  'COMMON.CONFIRM': 'Confirm',
  'COMMON.CLOSE': 'Close',
  'COMMON.I.GOT.IT': 'I got it',
  'COMMON.DELETE': 'Delete',
  'COMMON.REMOVE': 'Remove',
  'COMMON.NEWLY.ADDED': 'New',
  'COMMON.CREATE': 'Create',
  'COMMON.EDIT': 'Edit',
  'COMMON.SETTING': 'Setting',
  'COMMON.SETTINGS': 'Settings',
  'COMMON.SET.UP': 'Set up',
  'COMMON.REVOKE': 'Revoke',
  'COMMON.CLEAR.AWAY': 'Clear away',
  'COMMON.SAVE': 'Save',
  'COMMON.DON.T.SAVE': "Don't save",
  'COMMON.SAVE.CHECK': 'Save and check',
  'COMMON.SAVE.EXIT': 'Save and quit',
  'COMMON.SAVE.USE': 'Save and use',
  'COMMON.CONTINUE': 'Continue',
  'COMMON.SAVE.CONFIGURE': 'Save',
  'COMMON.COPY': 'Copy',
  'COMMON.DUPLICATE': 'Duplicate',
  'COMMON.COPIED': 'Copied',
  'COMMON.COPIED.TO.CLIPBOARD': 'Copied to clipboard',
  'COMMON.COPY.SUCCEEDED': 'Copied successfully',
  'COMMON.COPY.FAILED': 'Copied failed',
  'COMMON.DETAILS': 'Details',
  'COMMON.VIEW.DETAILS': 'View details',
  'COMMON.EXPORT.DETAILS': 'Export details',
  'COMMON.PREVIEW': 'Preview',
  'COMMON.DOWNLOAD': 'Download',
  'COMMON.TEMPLATE': 'Template',
  'COMMON.DOWNLOAD.TEMPLATE': 'Download template',
  'COMMON.SIGN.OUT': 'Sign out',
  'COMMON.START': 'Start',
  'COMMON.RESTART': 'Restart',
  'COMMON.TERMINATION': 'Terminate',
  'COMMON.TERMINATION.STATE': 'Terminated',
  'COMMON.SUSPEND': 'Suspend',
  'COMMON.OPERATION': 'Action',
  'COMMON.PREV': 'Previous',
  'COMMON.PREV.GO.BACK': 'Go back',
  'COMMON.NEXT': 'Next',
  'COMMON.SUBMIT': 'Submit',
  'COMMON.EXPLAIN': 'Explain',
  'COMMON.ANY': 'Any',
  'COMMON.ALL': 'All',
  'COMMON.ALLS': 'All',
  'COMMON.SELECT.ALL': 'Select all',
  'COMMON.SEARCH': 'Search',
  'COMMON.FORMAT': 'Format',
  'COMMON.RENAME': 'Rename',
  'COMMON.SUBMIT.SUCCEEDED': 'Submitted successfully',
  'COMMON.SAVE.SUCCEEDED': 'Saved successfully',
  'COMMON.SEND.SUCCEEDED': 'Successfully sent',
  'COMMON.EDIT.SUCCEEDED': 'Edit succeeded',
  'COMMON.PUBLISH.SUCCESS': 'Launched successfully',
  'COMMON.SUCCESSFUL.APPLICATION': 'Application succeeded',
  'COMMON.DELETE.SUCCEEDED': 'Successfully deleted',
  'COMMON.DELETE.FAILED': 'Deletion failed',
  'COMMON.REVOKE.SUCCEEDED': 'Undo succeeded',
  'COMMON.REVOKE.FAILED': 'Undo failed',
  'COMMON.STATUS.SUCCEEDED': 'Started successfully',
  'COMMON.PAUSE.SUCCEEDED': 'Paused successfully',
  'COMMON.TERMINATION.SUCCEEDED': 'Terminated successfully',
  'COMMON.URGED.SUCCESSFULLY': 'Urged successfully',
  'COMMON.UPLOAD.SUCCEEDED': 'Uploaded successfully',
  'COMMON.CANCEL.UPLOAD': 'Remove file',
  'COMMON.RE.UPLOAD': 'Reupload',
  'COMMON.SELECT.FILE': 'Select file',
  'COMMON.PLEASE.SELECT.UPLOAD.FILE': 'Select a file to upload',
  'COMMON.UPLOAD.ERROR.TRY.AGAIN': 'Upload failed, please try again',
  'COMMON.UPLOAD.ERROR.ALREADY.DELETE': 'Picture has been deleted',
  'COMMON.UPLOAD.ERROR.NETWORK.ERROR':
    'Abnormal network request, please try again',
  'COMMON.UPLOAD.ERROR.GARBLED.CODE':
    'Upload failed, please check if the file has ineligible data',
  'COMMON.UPLOAD.FILE.BIG.WAIT': 'Uploading large file size, please wait',
  'COMMON.UPLOAD.ERROR.EXCEED': 'Excel file cannot exceed {maxSize}',
  'COMMON.UPLOAD.ERROR.html.exceed': 'HTML size cannot exceed 100KB',
  'COMMON.UPLOAD.ERROR.CELL.MAX.LENGTH':
    'Cell content in file cannot exceed {maxLength} characters',
  'COMMON.UPLOAD.ERROR.AUDIT.FILE':
    'Upload failed, please check the file content',
  'COMMON.FILE.UPLOADING': 'Uploading file',
  'COMMON.CLICK.UPLOAD': 'Upload',
  'COMMON.DOWNLOAD.FAIL': 'Download failed',
  'COMMON.DRAG.AREA': 'Drag to this area',
  'COMMON.RELEASE.MOUSE': 'Release the mouse',
  'COMMON.MORE': 'More',
  'COMMON.TIME': 'Time',
  'COMMON.SEARCHSEC': 'Search',
  'COMMON.RESET': 'Reset',
  'COMMON.REFRESH': 'Refresh',
  'COMMON.REFRESH.PAGE': 'Refresh page',
  'COMMON.UNCATE': 'Uncategorized (default)',
  'COMMON.TEMPLATE.EXCEED': 'File size exceeds limit',
  'COMMON.EXPORT': 'Export',
  'COMMON.ORDER.NUMBER': 'No.',
  'COMMON.LANGUAGE': 'Language',
  'COMMON.LOCATION': 'Location',
  'COMMON.SWITCH.LANGUAGE': 'Switch to Chinese',
  'COMMON.CH': 'CH',
  'COMMON.EN': 'EN',
  'COMMON.OTHER': 'Other',
  'COMMON.OTHERS': 'Others',
  'COMMON.COUNTRY': 'Region',
  'COMMON.ALL.COUNTRIES': 'All regions',
  'COMMON.SUBSCRIBE': 'Subscribe',
  'COMMON.UNSUBSCRIBE': 'Unsubscribe',
  'COMMON.LOADING': 'Loading',
  'COMMON.LOADING.LOWERCASE': 'loading',
  'COMMON.NO.DATA': 'No data',
  'COMMON.NO.MORE.DATA': 'No more data',
  'COMMON.NO.LOADING.FAILED': 'Failed to load',
  'COMMON.RETRY': 'Retry',
  'COMMON.VIEW.ALL': 'View all',
  'COMMON.SEE.MORE': 'View more',
  'COMMON.SEE': 'View',
  'COMMON.TOTAL': 'Total',
  'COMMON.ADOPT': 'Approve',
  'COMMON.REJECT': 'Reject',
  'COMMON.STATUS.ADOPT': 'Approved',
  'COMMON.STATUS.REJECT': 'Rejected',
  'COMMON.URGE': 'Urge',
  'COMMON.URGED': 'Urged',
  'COMMON.SOURCE': 'Source',
  'COMMON.APPLY': 'Apply',
  'COMMON.BACK': 'Back',
  'COMMON.TAG': 'Tags',
  'COMMON.FIELD.NAME': 'Attribute name',
  'COMMON.DATA.TYPE': 'Data type',
  'COMMON.VALUE': 'Value',
  'COMMON.CREATED.BY': 'Created by',
  'COMMON.LAST.UPDATE.BY': 'Last updated by',
  'COMMON.LAST.MODIFIED.TIME': 'Last modification time',
  'COMMON.LAST.UPDATE.TIME': 'Last update time',
  'COMMON.REMARKS': 'Remarks',
  'COMMON.DEFAULT': 'Default',
  'COMMON.EMAIL': 'Email',
  'COMMON.FIXED': 'Fixed',
  'COMMON.DYNAMIC': 'Dynamic',
  'COMMON.RECORD.COUNT': 'Total items: {recordCount}',
  'COMMON.SEND.CODE': 'Send code',
  'COMMON.SENT.SUCCESS': 'Sent successfully',
  'COMMON.ENTER.NOW': 'Enter now',
  'COMMON.ENTER': 'Enter',
  'COMMON.CREATE.NOW': 'Create now',
  'COMMON.PREFERENCE': 'Subscriber preferences',
  'COMMON.NONE': 'None',
  'COMMON.EXPAND': 'Expand',
  'COMMON.COLLAPSE': 'Collapse',
  'COMMON.URL': 'URL',
  'COMMON.STATUS': 'Status',
  'COMMON.DONE': 'Done',
  'COMMON.ENABLE': 'Enable',
  'COMMON.DISABLE': 'Disable',
  'COMMON.ENABLED': 'Enabled',
  'COMMON.NOT.ENABLED': 'Disabled',
  'COMMON.DISABLED': 'Disabled',
  'COMMON.DATA.ERROR.PLEASE.CHECK': 'Data error, Please check',

  // 快捷时间选择
  'COMMON.TO': 'To',
  'COMMON.NOW': 'Now',
  'COMMON.FIVE.MINUTES.LATER': 'After 5 minutes',
  'COMMON.ONE.DAY.LATER': 'After 1 day',
  'COMMON.MORNING': 'Morning',
  'COMMON.AFTERNOON': 'Afternoon',
  'COMMON.NIGHT': 'Night',
  'COMMON.HOURS': 'Hour(s)',
  'COMMON.DAYS': 'Day(s)',
  'COMMON.DAYS.UNIT': 'Day(s)',
  'COMMON.WEEKS': 'Week(s)',

  // 提示语集 - 询问
  'COMMON.IS.SUBSCRIBE': 'Subscribe?',
  'COMMON.IS.UNSUBSRIBE': 'Cancel subscription?',
  'COMMON.IS.DELETE': 'Are you sure you want to delete this?',
  'COMMON.SELECT.ONE': 'Select at least one item',
  'COMMON.QUERY.NUMBER.RESULT': 'The result of the {num} bar is queried',

  // 提示语集 - 请输入、请选择
  /** 请选择 */
  'COMMON.PLEASE.SELECT': 'Please select',
  'COMMON.PLEASE.SELECT.DATE': 'Please select a date',
  'COMMON.PLEASE.SELECT.TIME': 'Please select a time',
  'COMMON.PLEASE.SELECT.SOURCE': 'Please select a source',
  'COMMON.PLEASE.SELECT.LABEL': 'Please select a tag',
  'COMMON.PLEASE.SELECT.SEGMENT': 'Please select a segment',
  'COMMON.PLEASE.SELECT.LANGUAGE': 'Please select a language',
  'COMMON.PLEASE.SELECT.LOCATION': 'Please select a region',
  'COMMON.PLEASE.SELECT.PREFERENCE': 'Please select subscription groups',
  'COMMON.PLEASE.SELECT.SENDER.NAME': 'Please select a sender name',
  'COMMON.PLEASE.SELECT.SENDER.ADDRESS': 'Please select a sender address',
  'COMMON.PLEASE.SELECT.SENDER.DOMAIN': 'Please select a sender domain',
  /** 选择 */
  'COMMON.SELECT': 'Select',
  'COMMON.SELECT.DATE': 'Select date',
  'COMMON.SELECT.TIME': 'Select time',
  'COMMON.SELECT.SOURCE': 'Select source',
  'COMMON.SELECT.LABEL': 'Select tag',
  'COMMON.SELECT.SEGMENT': 'Select segment',
  'COMMON.SELECT.LANGUAGE': 'Select language',
  'COMMON.SELECT.LOCATION': 'Select region',
  'COMMON.SELECT.PREFERENCE': 'Select subscription groups',
  'COMMON.SELECT.SENDER.NAME': 'Select sender name',
  'COMMON.SELECT.SENDER.ADDRESS': 'Select sender address',
  'COMMON.SELECT.SENDER.DOMAIN': 'Select sender domain',
  'COMMON.SELECT.VALUES': 'Select value(s)',
  /** 请输入 */
  'COMMON.PLEASE.ENTER': 'Please enter',
  'COMMON.ENTER.HERE': 'Enter here',
  'COMMON.TYPE.HERE': 'Type here',
  'COMMON.INPUT.ERROR': 'Input error, please enter again',
  'COMMON.PLEASE.ENTER.EMAIL.REG': 'Please enter a valid email address',
  'COMMON.PLEASE.ENTER.EMAIL.EXIST': 'The entered email address already exists',
  'COMMON.PLEASE.ENTER.REMARKS': 'Please enter a remarks',
  'COMMON.PLEASE.SELECT.SUBJECT': 'Please enter a subject line',
  'COMMON.PLEASE.ENTER.XX.DIGIT.CODE': 'Please enter the {num} digit code',
  'COMMON.PLEASE.ENTER.VALUES': 'Enter value(s)',
  /** 输入 */
  'COMMON.INPUT': 'Enter',
  'COMMON.ENTER.REMARKS': 'Enter remarks',
  'COMMON.SELECT.SUBJECT': 'Enter subject line',

  // 提示语集 - 无权限
  'COMMON.NO.PERMISSION.HEADERS.TITLE': 'No permission',
  'COMMON.NO.PERMISSION.TO.ACCESS':
    'You do not have access to this feature. Please contact the {HIGHEST_AUTHS} for assistance.',
  'COMMON.NO.PERMISSION.DEMO':
    'This feature is currently not available in the demo project',
  'COMMON.NO.PERMISSION.DEMO.EXPLAIN.BTN1': 'Join existing project',
  'COMMON.NO.PERMISSION.DEMO.EXPLAIN': ' or ',
  'COMMON.NO.PERMISSION.DEMO.EXPLAIN.BTN2': 'Create new project',

  // 左侧菜单
  'LEFT.MENU.PROJECT': 'Project',
  'LEFT.MENU.FUNCTION': 'Feature',
  'LEFT.MENU.HOME': 'Home',
  'LEFT.MENU.CONTACTS': 'Contacts',
  'LEFT.MENU.EMAIL': 'Email',
  'LEFT.MENU.DASHBOARD': 'Dashboard',
  'LEFT.MENU.OVERVIEW': 'Overview',
  'LEFT.MENU.ORGANIZE': 'Management',
  'LEFT.MENU.ECONOMY': 'Assets',
  'LEFT.MENU.ANALYTICS': 'Analytics',
  'LEFT.MENU.EVENT': 'Campaigns',
  'LEFT.MENU.EVENT1': 'Regular',
  'LEFT.MENU.EVENT2': 'Recurring',
  'LEFT.MENU.EVENT3': 'Approval request',
  'LEFT.MENU.EVENT4': 'A/B test',
  'LEFT.MENU.EVENT5': 'Automated campaigns',
  'LEFT.MENU.PLAYER.JOURNEY': 'Player journey',
  'LEFT.MENU.EVENT6': 'Journeys',
  'LEFT.MENU.EVENT.WHATSAPP': 'Campaigns',
  'LEFT.MENU.WHATSAPP': 'WhatsApp',
  'LEFT.MENU.USER': 'Contacts',
  'LEFT.MENU.USER0': 'Segments',
  'LEFT.MENU.USER1': 'All contacts',
  'LEFT.MENU.USER2': 'Tags',
  'LEFT.MENU.USER3': 'Subscriber preferences',
  'LEFT.MENU.USER4': 'Forms',
  'LEFT.MENU.TEMPLATE': 'Templates',
  'LEFT.MENU.TEMPLATE.MARKET': 'Marketing',
  'LEFT.MENU.TEMPLATE.TRANSACTION': 'Transactional',
  'LEFT.MENU.TEMPLATE1': 'Email templates',
  'LEFT.MENU.TEMPLATE2': 'SMS template',
  'LEFT.MENU.TEMPLATE3': 'Key pools',
  'LEFT.MENU.WHATSAPP.TEMPLATE': 'Templates',
  'LEFT.MENU.DATA': 'Analytics',
  'LEFT.MENU.ACTIVITY.REPORT': 'Campaign reports',
  // 'LEFT.MENU.CONTACT.REPORT': 'Dashboard',
  'LEFT.MENU.AUTOMATIONS': 'Automations',
  'LEFT.MENU.PLAYTEST.HUB': 'Playtest Hub',
  'LEFT.MENU.TEST.MANAGEMENT': 'Test Management',
  'LEFT.MENU.TESTER.LIST': 'Tester list',

  'LEFT.MENU.Hi': 'Hi {accountName}',
  'LEFT.MENU.MY.PROJECT': 'My project',
  'LEFT.MENU.SETTING': 'Project settings',
  'LEFT.MENU.EXPORT.CENTER': 'Export Center',
  'LEFT.MENU.MY.PROFILES': 'Account',
  'LEFT.MENU.PERMISSION.LIST': 'Pending my approval',
  'LEFT.MENU.DEVELOPERS': 'API reference',
  'LEFT.MENU.USE.GUIDE': 'Help center',
  'LEFT.MENU.VERSIONS': 'Versions',
  'LEFT.MENU.VERSIONS.TITLE': 'New features',

  // 符号
  'COMMON.SYMBOL.COLON': ':',
  'COMMON.SYMBOL.COMMA': ',',
  'COMMON.SYMBOL.SEMICOLON': ';',

  // 联系人模板
  LOCATION_CODE: 'region code',
  LANGUAGE_CODE: 'language code',
  EMAIL_ADDRESS: 'Email',

  'COMMON.CAMPAIGN': 'campaign',
  'COMMON.FORM': 'form',

  // 抽屉
  'COMMON.DRAWER.CHECKBOX.DESC': 'Do not automatically expand again',

  'COMMON.SENDER.NAME.IS.DELETED': "The sender's name does not exist.",

  // 时间
  'COMMON.UPDATE.TIME': 'Update time',
  // 创建导出请求提示
  'CREATED.EXPORT.REQ.INFOR.READY':
    'Export has started. An email will be sent to {email} after completion.',
};
